<div class="note-form" [ngClass]="(position$ | async)" #noteForm>
    <div class="note-tags">
        <div class="tag" *ngIf="note.markedUser != null">
            {{ note.markedUser.username }}
            <div class="remove-tag" title="Tag entfernen" (click)="note.markedUser = null" *ngIf="userSearchEnabled">
                <span class="iconify" data-icon="eva:close-outline"></span>
            </div>
        </div>
        <div class="tag" *ngIf="note.customer != null">
            {{ note.customer.companyDisplayName }}
            <div class="remove-tag" title="Tag entfernen" (click)="note.customer = null" *ngIf="customerSearchEnabled">
                <span class="iconify" data-icon="eva:close-outline"></span>
            </div>
        </div>
        <div class="tag" *ngIf="note.cooperation != null">
            {{ note.cooperation.name }}
            <div class="remove-tag" title="Tag entfernen" (click)="note.cooperation = null" *ngIf="cooperationSearchEnabled">
                <span class="iconify" data-icon="eva:close-outline"></span>
            </div>
        </div>
    </div>
    <div class="input-wrapper">
        <div #searchMenuTrigger [matMenuTriggerFor]="searchMenu" class="visibility-hidden"></div>
        <textarea #noteInput (keydown)="keyDown($event)" [placeholder]="placeholderText" type="text" [(ngModel)]="note.text"></textarea>

        <mat-menu #searchMenu class="search-menu" (click)="$event.stopPropagation()" (closed)="menuClosed()">
            <div class="search-query" [style.width]="noteForm.getBoundingClientRect().width + 'px'">
                <input (blur)="searchQueryInput.focus()" (keydown.escape)="escapePressed()" (keydown.backspace)="backspacePressed()" (keydown.enter)="saveSearch()" #searchQueryInput ngModel (ngModelChange)="setQuery($event)" type="text" placeholder="Nach Kunden, Artists, Kooperationen suchen..." />
            </div>
            <div class="search-results">
                <button mat-menu-item *ngFor="let result of (results$ | async); index as i" [class.active]="selectedIndex == i" (click)="applyContext(result)">
                    <div class="label">{{ result.label }}</div>
                    <div class="text-xs text-gray-600" *ngIf="result.description">{{ result.description }}</div>
                    <div class="text-2xs">
                        <span *ngIf="result.type == 'customer'">Kunde</span>
                        <span *ngIf="result.type == 'cooperation'">Kooperation</span>
                        <span *ngIf="result.type == 'user'">
                    <span *ngIf="result.originalObject.roles.indexOf('ROLE_CRM_MANAGER') >= 0">Manager</span>
                    <span *ngIf="result.originalObject.roles.indexOf('ROLE_CRM_MANAGER') < 0 && result.originalObject.roles.indexOf('ROLE_CRM_INFLUENCER') >= 0">Artist</span>
                  </span>
                    </div>
                </button>
                <button mat-menu-item (click)="addCustomer()" *ngIf="customerSearchEnabled">
                    <div class="add-customer" *ngIf="!matchInType('customer')">
                        + Unternehmen erstellen
                    </div>
                </button>
            </div>
        </mat-menu>

    </div>
</div>
